import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Transactions from '@src/containers2/Transactions';
import { bemCssModules, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import { accountsActions, useStore } from '@modules';
import { FiatCurrencyEnum } from '@modules/global/types';
import { IbanStatusesEnum, VerificationStatusesEnum } from '@modules/user/types';

import BalanceLayoutOld from '@layouts/BalanceLayoutOld';

import Balance from './Balance';

import style from './AccountsMain.scss';

const cn = bemCssModules(style, 'AccountsMain');
const ti = getTestId('AccountsMain');

const { created, user_has_intention } = IbanStatusesEnum;

export type TAccountsMain = {
  className?: string;
};

const AccountsMain: CustomFC<TAccountsMain> = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [{ user, accounts }, dispatch] = useStore();
  const userData = user.data;
  const { details } = accounts;

  const isIbanCreated = userData?.iban_status === created;
  const POAStatus = user.data?.checks.proof_of_address;
  const isIbanUserHasIntention =
    userData?.iban_status === user_has_intention ||
    POAStatus === VerificationStatusesEnum.under_review;
  const ibanAccountNumber = `${FiatCurrencyEnum.EUR} · ${
    accounts.details[0]?.iban?.slice(-4) || ''
  }`;

  useEffect(() => {
    if (userData) {
      if (isIbanCreated) {
        dispatch(accountsActions.getAccounts());
        navigate(CONST.nav.accounts);
      } else if (isIbanUserHasIntention && user.data?.phone) {
        navigate(CONST.nav.accountsVerification);
      } else navigate(CONST.nav.accountsIntro);
    }
  }, [userData]);

  return (
    <BalanceLayoutOld
      className={cn(null, [className])}
      tabs={[ibanAccountNumber]}
      activeTab={ibanAccountNumber}
      balance={details?.[0]?.fiat_balance}
      routes={{
        withdraw: CONST.nav.accountsSend,
        topup: CONST.nav.accountsTopup,
      }}
    >
      <Balance className={cn('balance')} />
      <Link to={CONST.nav.accountsDetails} className={cn('details')} data-testid={ti('details')}>
        {t('iban.account_details.title')}
      </Link>
      <Transactions
        className={cn('transactions')}
        types={['fiat_sell', 'fiat_withdraw', 'fiat_deposit', 'iban_refund', 'iban_charge']}
      />
    </BalanceLayoutOld>
  );
};

export default AccountsMain;
